import React, { useContext, useState, useEffect } from 'react';
import Header from '../Common/Header';
import Sidebar from '../Common/Sidebar';
import Footer from '../Common/Footer';
import { GMCContext } from '../../GMCContext';
import Swal from 'sweetalert2';
import Copy from '../Common/Copy';
import axios from 'axios';
import Web3 from 'web3';
import Pagination from '../Common/Pagination';
import useEthersSigner from './useEthersSigner'; // Import the hook for getting signer
import { Contract, ethers, utils } from "ethers"; // Import ethers
import { ConnectButton } from "@rainbow-me/rainbowkit";

import { useAccount, useConnect, useDisconnect } from 'wagmi';


export default function PendingWithdrwalsidebar() {
    const { togel, setTogel, isSidebarEnabled, setIsSidebarEnabled, web3, formatDateTime, settings, toastSuccess, toastError } = useContext(GMCContext);
    const signer = useEthersSigner(); // Call the hook here
    const { formatAddress } = useContext(GMCContext);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [pages, setPages] = useState(1);
    const [data, setdata] = useState([]);
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState("");
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [authNumber, setAuthNumber] = useState('');
    const [msg, setMsg] = useState('');
    const [showMsg, setShowMsg] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [error, setError] = useState(false);
    const [account, setAccount] = useState(null);
    const [web3c, setWeb3c] = useState(null);
    const [value, setValue] = useState(0);
    const [trdone, settrdone] = useState(true);
    const [fromdate, setfromdate] = useState(null);
    const [todate, settodate] = useState(null);
    const [selected_address, setselected_address] = useState([]);
    const [selected_username, setselected_username] = useState([]);
    const [selected_address_amt, setselected_address_amt] = useState([]);
    const [selected_address_amt_as, setselected_address_amt_as] = useState([]);
    // console.log('contract', settings[0]?.withdrawal_contract)


    const randomHash = utils.id(Math.random().toString());
    // console.log('randomhash', randomHash);


    const insertCode = async () => {
        try {
            const state = JSON.parse(localStorage.getItem('mark#0143'));
            const response = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
                method: "verify",
                submethod: "insert",
                key: process.env.REACT_APP_KEY,
                authNumber,
                username: state.username,
                _id: state._id,
            });

            const { resCode, error, token } = response.data;

            if (resCode === 200 && token) {
                setMsg("Verified Successfully");
                setShowMsg(true);
                setIsAuthenticated(true);
            } else {
                setErrorMessage(error || "Verification Failed. Please Try Again.");
                setError(true);
            }
        } catch (err) {
            console.error("Error Inserting Data:", err);
            setErrorMessage("Network Error. Please Try Again Later.");
            setError(true);
        }
    };


    const connectMetaMask = async () => {

        if (window.ethereum) {
            // MetaMask exists
            try {
                // Request account access if needed
                const accounts = await window.ethereum.request({ method: "eth_requestAccounts" });
                const web3Instance = new Web3(window.ethereum);

                // Set the web3 instance and the user's account
                setWeb3c(web3Instance);
                setAccount(accounts[0]);

                console.log("Connected Account:", accounts[0]);
            } catch (error) {
                console.error("User Denied Account Access Or Error Occurred:", error);
            }
        } else {
            // MetaMask is not installed
            alert("Please Install MetaMask To Use This App.");
        }
    };


    const getData = async () => {
        // console.log('first')
        try {
            setLoading(true);
            await axios
                .post(process.env.REACT_APP_BACKEND_LINK, {
                    method: "withdrawal",
                    submethod: "getp",
                    key: process.env.REACT_APP_KEY,
                    search: search,
                    type: 1,
                    fromdate: fromdate,
                    todate: todate,
                    page: currentPage,
                    pageSize: pageSize,
                })
                .then((res) => {
                    // console.log("user data", res.data.data);
                    setLoading(false);
                    if (res.data.error) {
                        setdata(res.data.data);
                        return "";
                    }
                    setdata(res.data.data);
                    setPages(Math.ceil(res.data.dataLength / pageSize));
                });
        } catch (err) {
            console.log("Error : ", err);
            setLoading(false);
        }
    };


    const selectAll = (event) => {
        if (event?.target?.checked) {
            // Reset arrays and total amount to start fresh
            let allSelectedAddresses = [];
            let allSelectedUsername = [];
            let allSelectedAmountsWei = [];
            let allSelectedAmounts = [];
            let totalAmount = 0;

            // Loop through all data to check each item and accumulate values
            data.forEach((item, index) => {
                const checkbox = document.getElementById(`chkbox${index}`);
                checkbox.checked = true;  // Check the checkbox

                const address = item?.address || ""; // fallback to empty string if address is missing
                const username = item?.username || "Unknown User"; // fallback if username is missing
                const amount = parseFloat(item?.amount) || 0; // fallback to 0 if amount is missing or invalid
                const token = parseFloat(item?.totalrcv) || 0; // fallback to 0 if token is missing or invalid
                const amountWei = Web3?.utils?.toWei(item?.t_rcv?.toString() || "0", "ether"); // fallback to "0" if t_rcv is missing

                // console.log("Address:", address, "Username:", username, "AmountWei:", amountWei);

                allSelectedAddresses.push(address);
                allSelectedUsername.push(username);
                allSelectedAmountsWei.push(amountWei);
                allSelectedAmounts.push(amount);
                totalAmount += token;
            });

            // Update state with new selection
            setselected_address(allSelectedAddresses);
            setselected_username(allSelectedUsername);
            setselected_address_amt(allSelectedAmountsWei);
            setselected_address_amt_as(allSelectedAmounts);
            setValue(totalAmount);

        } else {
            // Uncheck all checkboxes and reset state
            data.forEach((item, index) => {
                const checkbox = document.getElementById(`chkbox${index}`);
                checkbox.checked = false;  // Uncheck the checkbox
            });

            setselected_address([]);
            setselected_username([]);
            setselected_address_amt([]);
            setselected_address_amt_as([]);
            setValue(0);
        }
    };

    const { JsonRpcProvider } = ethers.providers; // Import JsonRpcProvider from the providers namespace


    const withdrawMultiple = async () => {
        // console.log("log", selected_address, selected_address_amt);

        if (!signer) {
            console.log("Signer Is Not Available");
            return;
        }

        settrdone(false);

        // Define the Arbitrum provider (connecting to the Arbitrum network)
        const arbitrumRpcUrl = "https://bsc-dataseed1.binance.org/"; // Arbitrum mainnet RPC URL
        const provider = new JsonRpcProvider(arbitrumRpcUrl); // Create the provider using the new method

        try {
            // // Create contract instance using ethers.js
            // const contract = new Contract(settings[0].withdrawal_contract, JSON.parse(settings[0].withdrawal_contract_abi), signer);
            // // console.log("sendifn");

            // // Estimate gas before sending the transaction
            // const tx = await contract.Withdrawal(selected_address, selected_address_amt, value);

            // console.log("Transaction sent, waiting for confirmation...");
            // console.log("Transaction successful:", tx);
            // // console.log("Transaction mined in block:", receipt.blockNumber);

            // Call backend API to register the withdrawal
            await axios
                .post(process.env.REACT_APP_BACKEND_LINK, {
                    method: "withdrawal",
                    submethod: "masswithdrw",
                    key: process.env.REACT_APP_KEY,
                    hash: randomHash, // Corrected from res.transactionHash
                    address: selected_address,
                    username: selected_username,
                    amount: selected_address_amt_as,
                    total: value, // Total value for the withdrawal
                })
                .then((response) => {
                    // Uncheck checkboxes after the transaction
                    for (let i = 0; i < selected_address.length; i++) {
                        const checkbox = document.getElementById(`chkbox${i}`);
                        if (checkbox) {
                            checkbox.checked = false;
                        }
                    }

                    getData();
                    setselected_address([]);
                    setselected_username([]);
                    setselected_address_amt([]);
                    setValue(0);

                    if (response.data.error) {
                        return "";
                    }

                    toastSuccess("Transaction Done");
                });

        } catch (err) {
            console.error("Error In withdrawMultiple:", err);
            settrdone(true);
        }

        settrdone(true);
    };

    //  for offlinr check for transactio


    // const withdrawMultiple = async () => {
    //     settrdone(false);

    //     try {
    //         console.log("Processing withdrawal...");

    //         // Generate a random transaction hash
    //         const randomHash = utils.id(Math.random().toString()); 

    //         // Call backend API to register the withdrawal
    //         await axios.post(process.env.REACT_APP_BACKEND_LINK, {
    //             method: "withdrawal",
    //             submethod: "masswithdrw",
    //             key: process.env.REACT_APP_KEY,
    //             address: selected_address,
    //             username: selected_username,
    //             hash: randomHash, // Attach the generated hash
    //             amount: selected_address_amt_as,
    //             total: value, // Total withdrawal amount
    //         });

    //         // Uncheck checkboxes after processing withdrawal
    //         selected_address.forEach((_, i) => {
    //             const checkbox = document.getElementById(`chkbox${i}`);
    //             if (checkbox) checkbox.checked = false;
    //         });

    //         getData();
    //         setselected_address([]);
    //         setselected_username([]);
    //         setselected_address_amt([]);
    //         setValue(0);

    //         toastSuccess("Withdrawal Processed");

    //     } catch (err) {
    //         console.error("Error in withdrawMultiple:", err);
    //     }

    //     settrdone(true);
    // };


    const handleChange = (event, address, amount, username, fromname, totalrcv) => {
        console.log('Event Triggered With Values:', address, amount, username, fromname, totalrcv);

        if (event?.target?.checked) {
            setselected_address(prevState => {
                const updatedAddress = [...prevState, address];
                console.log("Updated selected_address", updatedAddress);
                return updatedAddress;
            });

            setselected_username(prevState => {
                const updatedUsername = [...prevState, username];
                console.log("Updated selected_username", updatedUsername);
                return updatedUsername;
            });
            const amt = totalrcv; // Assuming `receive` is already in the correct unit
            console.log("Amount In Wei:", amt);

            setselected_address_amt(prevState => {
                const updatedAmt = [...prevState, amt];
                console.log("Updated selected_address_amt", updatedAmt);
                return updatedAmt;
            });

            setselected_address_amt_as(prevState => {
                const updatedAmtAs = [...prevState, amount];
                console.log("Updated selected_address_amt_as", updatedAmtAs);
                return updatedAmtAs;
            });

            setValue(prevValue => {
                const updatedValue = prevValue + parseFloat(totalrcv);
                console.log("Updated value", updatedValue);
                return updatedValue;
            });
        } else {
            // When the checkbox is unchecked, remove the address, username, and amount from the selected lists
            const index = selected_address.findIndex(item => item === address);

            if (index !== -1) {
                setselected_address(prevState => prevState.filter((_, ind) => ind !== index));
                setselected_username(prevState => prevState.filter((_, ind) => ind !== index));
                setselected_address_amt(prevState => prevState.filter((_, ind) => ind !== index));
                setselected_address_amt_as(prevState => prevState.filter((_, ind) => ind !== index));

                setValue(prevValue => prevValue - parseFloat(totalrcv));
            }
        }
    };

    // Now, useEffect can track state changes if you want to log after state has updated
    useEffect(() => {
        console.log('selected_address', selected_address);
        console.log('selected_username', selected_username);
        console.log('selected_address_amt', selected_address_amt);
        console.log('selected_address_amt_as', selected_address_amt_as);
    }, [selected_address, selected_username, selected_address_amt, selected_address_amt_as]);  // This will log whenever these states change

    useEffect(() => {
        if (search) {
            setCurrentPage(1);
        }
        if (fromdate && todate) {
            setCurrentPage(1);
        }
        getData();
    }, [pages, pageSize, currentPage, search]);

    useEffect(() => {
    }, [selected_address, selected_address_amt])

    const onCheckboxChange = (e, address, amount, username, fromname, totalrcv) => {
        console.log('onbox');

        e.preventDefault(); // prevent auto toggle

        Swal.fire({
            title: 'Confirm Withdrawal',
            html: `Are you sure you want to process a withdrawal for <strong>${address}</strong>?`,
            icon: 'warning',
            input: 'text',
            inputPlaceholder: 'Enter hash',
            inputAttributes: {
                autocapitalize: 'off'
            },
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, proceed!',
            cancelButtonText: 'Cancel',
            preConfirm: (inputValue) => {
                if (!inputValue) {
                    Swal.showValidationMessage('You must enter a hash');
                }
                return inputValue; // Returns the input value to `.then(result => { ... })`
            }
        }).then((result) => {
            if (result.isConfirmed && result.value) {
                const enteredHash = result.value;
                console.log('Entered hash:', enteredHash);
                handleChangedirect(result.isConfirmed, e, address, amount, username, fromname, totalrcv, enteredHash);
                // Proceed with withdrawal logic using enteredHash
            }
        });
    };
    const handleChangedirect = async (checked, event, address, amount, username, fromname, totalrcv, enteredHash) => {
        console.log('Event Triggered With Values:', address, amount, username, fromname, totalrcv);
        console.log('event?.target?.checked', checked);


        if (checked) {
            const updatedAddress = [address];
            const updatedUsername = [username];
            const updatedAmt = [totalrcv];
            const updatedAmtAs = [amount];
            const updateHashs = enteredHash;
            const updatedValue = value + parseFloat(totalrcv);

            // Set the updated state
            setselected_address(updatedAddress);
            setselected_username(updatedUsername);
            setselected_address_amt(updatedAmt);
            setselected_address_amt_as(updatedAmtAs);
            setValue(updatedValue);

            try {
                await axios.post(process.env.REACT_APP_BACKEND_LINK, {
                    method: "withdrawal",
                    submethod: "masswithdrw",
                    key: process.env.REACT_APP_KEY,
                    hash: randomHash, // Make sure this is generated before
                    address: updatedAddress,
                    username: updatedUsername,
                    amount: updatedAmtAs,
                    total: updatedValue,
                    enterhash: updateHashs
                });

                // console.log("POST request successful");

                getData(); // Refresh data
                setselected_address([]);
                setselected_username([]);
                setselected_address_amt([]);
                setselected_address_amt_as([]);
                setValue(0); // Reset value

            } catch (err) {
                console.error("Error Sending Withdrawal Data:", err);
            }
        } else {
            // Handle unchecking
            const index = selected_address.findIndex(item => item === address);

            if (index !== -1) {
                const updatedAddress = selected_address.filter((_, ind) => ind !== index);
                const updatedUsername = selected_username.filter((_, ind) => ind !== index);
                const updatedAmt = selected_address_amt.filter((_, ind) => ind !== index);
                const updatedAmtAs = selected_address_amt_as.filter((_, ind) => ind !== index);
                const updatedValue = value - parseFloat(totalrcv);

                setselected_address(updatedAddress);
                setselected_username(updatedUsername);
                setselected_address_amt(updatedAmt);
                setselected_address_amt_as(updatedAmtAs);
                setValue(updatedValue);
            }
        }
    };

    const handleReject = (username, address) => {
        Swal.fire({
            title: "Are you sure?",
            html: `
      <p style="margin-bottom:8px;">
        <strong>This withdrawal request will be rejected!</strong>
      </p>
      <p><b>Username:</b> ${username}</p>
      <p><b>Address:</b> ${address}</p>
    `,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085D6",
            confirmButtonText: "Yes, Reject",
            cancelButtonText: "Cancel",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
                        method: "withdrawal",
                        submethod: "reject",
                        username: username,
                        address: address,
                        key: process.env.REACT_APP_KEY,
                    });
                    console.log('res.data?.error', res.data?.error);
                    if (res.data?.resCode === 200) {
                        Swal.fire("Rejected!", res.data.msg, "success");
                        // :point_right: refresh list here if needed
                        getData();
                    } else {
                        Swal.fire("Error", res.data?.error || "Failed", "error");
                    }
                } catch (err) {
                    Swal.fire("Error", "Server error", "error");
                }
            }
        });
    };
    const handleManualWithdrawal = async (username, amount) => {
  const hash = generate3LetterHash(); // e.g. ABC
  const result = await Swal.fire({
    title: "Confirm Manual Withdrawal",
    html: `
      <p><b>Username:</b> ${username}</p>
      <p><b>Amount:</b> $${Number(amount).toFixed(2)}</p>
      <p style="color:red;">This withdrawal will be processed manually!</p>
    `,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, Proceed",
    cancelButtonText: "Cancel",
    confirmButtonColor: "#0D6EFD",
    cancelButtonColor: "#6C757D",
  });
  if (!result.isConfirmed) return;
  try {
    const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
      method: "withdrawal",
      submethod: "manual",
      username,
      amount,
      hash,
      key: process.env.REACT_APP_KEY,
    });
    if (res.data?.resCode === 200) {
      Swal.fire("Success", res.data.msg, "success");
      getData()
    } else {
      Swal.fire("Error", res.data?.error || "Failed", "error");
    }
  } catch (error) {
    Swal.fire("Error", "Server Error", "error");
  }
};
const generate3LetterHash = () => {
      const chars = "abcdefghijklmnopqrstuvwxyz0123456789";
        let result = "";
        for (let i = 0; i < 3; i++) {
            result += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return result;
    };

    return (
        <>
            <Header />
            <Sidebar />
            <div id="layout-wrapper">
                <div className="vertical-overlay" onClick={() => setIsSidebarEnabled((prev) => !prev)} />
                <div className="main-content">
                    <div className="page-content">
                        <div className="container-fluid">
                            {/* {!isAuthenticated ? (
                                // Authentication Form
                                <div className="col-md-6 mx-auto">
                                    <div className="card shadow-lg rounded p-4">
                                        <div className="text-center mb-4">
                                            <h4 className="text-primary">Verify Your Authentication Key!</h4>
                                        </div>
                                        <form autoComplete="off">
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    className="form-control form-control-lg bg-light border-light text-center"
                                                    placeholder="Enter Authentication Key"
                                                    onChange={(e) => setAuthNumber(e.target.value)}
                                                />
                                            </div>
                                        </form>
                                        {error && errorMessage && (
                                            <div className="alert alert-danger mt-3" role="alert">
                                                {errorMessage}
                                            </div>
                                        )}
                                        {showMsg && msg && (
                                            <div className="alert alert-success mt-3" role="alert">
                                                {msg}
                                            </div>
                                        )}
                                        <div className="mt-3">
                                            <button
                                                type="button"
                                                className="btn btn-success w-100"
                                                onClick={insertCode}
                                            >
                                                Confirm
                                            </button>
                                        </div>
                                    </div>
                                </div>

                            ) : (
                                <> */}
                            {/* Page Title Section */}
                            <div className="row">
                                <div className="col-12">
                                    <div className="page-title-box d-sm-flex align-items-center justify-content-between bg-galaxy-transparent">
                                        <ol className="breadcrumb m-0">
                                            <li className="breadcrumb-item"><a href="javascript: void(0);">Tables</a></li>
                                            <li className="breadcrumb-item active">Pending Withdrwal</li>
                                        </ol>
                                    </div>
                                </div>
                            </div>

                            {/* Member Report Table Section */}
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="card">
                                        <div className="card-header">
                                            <h4 className="card-title mb-0">Pending Withdrwal</h4>
                                        </div>
                                        <div className="card-body">
                                            <div className="listjs-table" id="customerList">
                                                {/* Table Action Buttons */}
                                                <div className="row g-4 mb-3">
                                                    <div className="col-sm-auto">
                                                    </div>
                                                    <div className="col-sm">
                                                        <div className="d-flex justify-content-sm-end">
                                                            <div className="search-box ms-2">
                                                                <input
                                                                    type="text"
                                                                    className="form-control search"
                                                                    placeholder="Search..."
                                                                    onChange={(e) => setSearch(e.target.value)}
                                                                />
                                                                <i className="ri-search-line search-icon" />
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                                <div className="d-flex pe-5">
                                                    <div>
                                                        <h5 className="py-3 px-5 text-break">🟢{account ? formatAddress(account) : "Not Connected"}</h5>
                                                        <h5 className="px-5">Total: {value} {process.env.REACT_APP_TICKER}</h5>
                                                        <p className="px-5">
                                                            <input className="p-5" type="checkbox" name="chkbox" id="chkbox" onChange={(ed) => selectAll(ed)} /> Select All
                                                        </p>
                                                    </div>
                                                    <div>
                                                        <button
                                                            className="btn btn-success m-1"
                                                            onClick={() => withdrawMultiple()}
                                                        >
                                                            Give Withdrawal
                                                        </button>
                                                        {account ? (
                                                            <>
                                                                {trdone ? (
                                                                    ""
                                                                ) : (
                                                                    <img
                                                                        src="/assets/images/loader.gif"
                                                                        style={{ height: "80px" }}
                                                                        alt="Loading"
                                                                    />
                                                                )}
                                                            </>
                                                        ) : (
                                                            <>
                                                                <ConnectButton />
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                                {/* Table */}
                                                <div className="table-responsive table-card mt-3 mb-1">
                                                    <table className="table align-middle table-nowrap" id="customerTable">
                                                        <thead className="table-light">
                                                            <tr>
                                                                <th scope="col" style={{ width: '50px' }}></th>
                                                                <th className="gridjs-th text-center">#</th>
                                                                <th className="gridjs-th text-center">Address</th>
                                                                <th className="gridjs-th text-center">Amount</th>
                                                                <th className="gridjs-th text-center">Token</th>
                                                                <th className="gridjs-th text-center">Fee</th>
                                                                <th className="gridjs-th text-center">Total Receive</th>
                                                                <th className="gridjs-th text-center">Date</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {data.length > 0 ? (
                                                                data.map((ele, i) => {
                                                                    const index = currentPage * pageSize - pageSize + (i + 1);
                                                                    return (
                                                                        <tr key={i}>
                                                                            <td class="gridjs-td">
                                                                                <div className="form-check">
                                                                                    <input className="form-check-input row-check" type="checkbox" name={`chkbox${i}`} id={`chkbox${i}`}
                                                                                        onChange={(ed) => handleChange(ed, ele.address, ele.amount, ele.username, ele.fromname, ele.totalrcv)} />
                                                                                    <label className="form-check-label"></label>
                                                                                </div>
                                                                            </td>
                                                                            <td className="gridjs-td text-center">{index}</td>
                                                                            <td className="gridjs-td text-center">
                                                                                <div>
                                                                                    <a
                                                                                        target="_blank"
                                                                                        className="text-primary"
                                                                                        href={`${process.env.REACT_APP_EXPLORER}/address/${ele.address}`}
                                                                                        rel="noreferrer"
                                                                                    >
                                                                                        <span className="name-title">Address:</span> {ele.address}
                                                                                    </a>
                                                                                    <Copy data={ele.address} /> {/* Use the Copy component */}
                                                                                </div>
                                                                                <div className="username-name">
                                                                                    <span className="name-title">ID:</span> {ele.username || "-"}
                                                                                    <Copy data={ele.username} />
                                                                                </div>
                                                                                <div className="username-name">
                                                                                    <span className="name-title">Name:</span> {ele.fromname || "-"}
                                                                                    <Copy data={ele.fromname} />
                                                                                </div>
                                                                            </td>
                                                                            <td className="gridjs-td text-center">$ {ele.amount || "0"}</td>
                                                                            <td className="gridjs-td text-center">{ele.token || "0"}</td>
                                                                            <td className="gridjs-td text-center">{parseFloat(ele.fee).toFixed(2)} ({(ele.fee_per || "0")}%)</td>
                                                                            <td className="gridjs-td text-center">$ {ele.totalrcv || "0"}</td>
                                                                            <td className="gridjs-td text-center">{formatDateTime(ele.createdAt)}</td>
                                                                            <td className="gridjs-td text-center">
                                                                                <button
                                                                                    className="btn btn-success m-1"
                                                                                    onClick={(ed) => onCheckboxChange(ed, ele.address, ele.amount, ele.username, ele.fromname, ele.totalrcv)}
                                                                                >
                                                                                    Give
                                                                                </button>
                                                                                <button
                                                                                    className="btn btn-danger" title='Reject Withdrwal'
                                                                                    onClick={() => handleReject(ele.username, ele.address)}
                                                                                >
                                                                                    <i class="bi bi-trash3" />
                                                                                </button> <br />
                                                                                <button
                                                                                    className="btn btn-primary"
                                                                                    title="Give Manual Withdrawal"
                                                                                    onClick={() =>
                                                                                        handleManualWithdrawal(ele.username,  ele.amount)
                                                                                    }
                                                                                >
                                                                                    Manual
                                                                                </button>
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                })
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan="11" className="text-center">
                                                                        No data available
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>

                                                {/* Pagination */}
                                                <Pagination
                                                    currentPage={currentPage}
                                                    setCurrentPage={setCurrentPage}
                                                    pageSize={pageSize}
                                                    setPageSize={setPageSize}
                                                    pages={pages}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* </>
                            )} */}
                        </div>
                    </div>
                </div>

            </div>
            <Footer />
        </>
    );
}